
window.VIDEOJS_NO_DYNAMIC_STYLE = true;

import 'video.js/dist/video-js.css';
import './video-js.less';

import videojs from 'video.js';
import 'videojs-resolution-switcher/lib/videojs-resolution-switcher.css';
import 'videojs-resolution-switcher';
import 'videojs-youtube';

export default videojs;